module.exports = __webpack_public_path__ + "img/pop-assets02.b58b4784.jpg";